import { ReactComponent as Success } from './success.svg';
import { ReactComponent as ToastCritical } from './toastCritical.svg';
const icons = {
  Success,
  ToastCritical,
};

export default icons;
